<template>
  <div>
    <div v-for="type in types" :key="type" class="flex flex-row items-center">
      <status-chip class="" :status="getStatusByType(type)"> </status-chip>
      <span class="item-text">{{ type }}</span>
    </div>
  </div>
</template>

<script>
import StatusChip from '@/components/StatusChip'
export default {
  name: 'StatusType',
  components: {
    StatusChip
  },
  props: {
    types: Array,
    status: Object
  },

  methods: {
    getStatusByType (type) {
      const typeClass = this.status[type.toLowerCase()]
      return {
        class: typeClass,
        verbose: getSubstanceVerboseByClass(typeClass)
      }
    }
  }
}

function getSubstanceVerboseByClass (typeClass) {
  if (typeClass === 'restriction-authorized') {
    return 'Substance autorisée'
  }
  if (typeClass === 'restriction-unauthorized') {
    return 'Substance non autorisée'
  }
}
</script>

<style></style>
